import { render } from "./LightModeIcon.vue?vue&type=template&id=00bc5a8d&ts=true"
import script from "./LightModeIcon.vue?vue&type=script&lang=ts"
export * from "./LightModeIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__